import { useQuery } from "@tanstack/react-query";
import { useCallback, useState } from "react";
import { studyGroupsApi } from "@/lib/humhub-api/studyGroups";

export const useMyStudyGroups = (sort = "newer", initialPage = 1, initialPerPage = 20) => {
  const [page, setPage] = useState<number>(initialPage);
  const [perPage, setPerPage] = useState<number>(initialPerPage);

  // React Queryでマイスタディグループ取得
  const {
    data: myStudyGroups,
    isLoading: loading,
    error: queryError,
    refetch,
  } = useQuery({
    queryKey: ["myStudyGroups", { sort, page, perPage }],
    queryFn: () => studyGroupsApi.getMyStudyGroups(sort, page, perPage),
    staleTime: 3 * 60 * 1000, // マイグループは3分間キャッシュ（参加状況の変更を考慮）
  });

  const handlePageChange = useCallback((newPage: number) => {
    setPage(newPage);
  }, []);

  const handlePerPageChange = useCallback((newPerPage: number) => {
    setPerPage(newPerPage);
    setPage(1);
  }, []);

  return {
    data: myStudyGroups?.results || [],
    pagination: myStudyGroups
      ? {
          total: myStudyGroups.total,
          page,
          perPage,
          pages: myStudyGroups.pages,
          links: myStudyGroups.links,
        }
      : undefined,
    isLoading: loading,
    error: queryError ? String(queryError) : null,
    handlePageChange,
    handlePerPageChange,
    refetch: () => refetch(),
  };
};
